import { isIos } from '@/utils'

export default {
    SET_VIEWDIRECTION(state, direction) {
        state.viewDirection = direction;
    },
    SET_WECHATSIGNURL(state, url) {
        // IOS仅记录第一次进入页面时的URL
        // IOS微信切换路由实际URL不变，只能使用第一进入页面的URL进行签名
        if (isIos() && state.wechatSignUrl !== '') {
            return;
        } 

        state.wechatSignUrl = url;
    }
}



// WEBPACK FOOTER //
// ./src/store/mutations.js